(() => {
  if (window.senderHeaderMenuInitialized) return;
  window.senderHeaderMenuInitialized = true;
  const controllers = new WeakMap();
  function bind(shell) {
    if (controllers.has(shell)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const desktopTrigger = shell.querySelector('[data-sender-products-menu-trigger]');
    const actionTrigger = shell.querySelector('[data-sender-action-trigger]');
    const mobileTrigger = shell.querySelector('[data-sender-mobile-menu-trigger]');
    const desktopLayer = shell.querySelector('[data-sender-products-menu-layer]');
    const mobileLayer = shell.querySelector('[data-sender-mobile-menu-layer]');
    let opener = null;
    let activeLayer = null;
    let focusFrame = null;
    const placeLayers = () => {
      document.documentElement.style.setProperty('--sender-products-menu-top', `${Math.max(0, shell.getBoundingClientRect().bottom)}px`);
      shell.classList.toggle('is-scrolled', window.scrollY > 16);
    };
    const close = (returnFocus = false) => {
      cancelAnimationFrame(focusFrame);
      [desktopLayer, mobileLayer].forEach(layer => { if (layer) layer.hidden = true; });
      [desktopTrigger, actionTrigger, mobileTrigger].forEach(trigger => trigger?.setAttribute('aria-expanded', 'false'));
      activeLayer = null;
      document.documentElement.classList.remove('sender-menu-open');
      if (returnFocus && opener?.isConnected) opener.focus({preventScroll: true});
    };
    const focusable = panel => [...panel.querySelectorAll('a[href],button:not([disabled]),summary,input:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length > 0);
    const open = (layer, trigger, promotion = false) => {
      close();
      if (!layer) return;
      opener = trigger;
      activeLayer = layer;
      placeLayers();
      layer.hidden = false;
      const panel = layer.querySelector('[role="dialog"]');
      panel.scrollTop = 0;
      (layer === desktopLayer ? desktopTrigger : mobileTrigger)?.setAttribute('aria-expanded', 'true');
      if (layer === desktopLayer) actionTrigger?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('sender-menu-open');
      focusFrame = requestAnimationFrame(() => {
        const target = promotion ? panel.querySelector('.sender-menu-promo__button') : panel.querySelector('[data-sender-panel-close]');
        (target || focusable(panel)[0])?.focus({preventScroll: true});
      });
    };
    desktopTrigger?.addEventListener('click', () => desktopLayer.hidden ? open(desktopLayer, desktopTrigger) : close(true), {signal});
    actionTrigger?.addEventListener('click', () => desktopLayer.hidden ? open(desktopLayer, actionTrigger, true) : close(true), {signal});
    mobileTrigger?.addEventListener('click', () => mobileLayer.hidden ? open(mobileLayer, mobileTrigger) : close(true), {signal});
    shell.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('[data-sender-products-menu-close],[data-sender-mobile-menu-close],[data-sender-panel-close]')) close(true);
      else if (event.target.closest('.sender-products-menu-content a,.sender-mobile-drawer__additional a,.sender-mobile-drawer__utility a,#cart-icon-bubble')) close();
    }, {signal});
    document.addEventListener('keydown', event => {
      if (!activeLayer) return;
      if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
      if (event.key !== 'Tab') return;
      const items = focusable(activeLayer.querySelector('[role="dialog"]'));
      if (!items.length) return;
      const first = items[0], last = items.at(-1), active = document.activeElement;
      if (event.shiftKey && (active === first || !items.includes(active))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (active === last || !items.includes(active))) { event.preventDefault(); first.focus(); }
    }, {signal});
    window.addEventListener('scroll', placeLayers, {passive: true, signal});
    window.addEventListener('resize', () => {
      placeLayers();
      if ((innerWidth < 990 && activeLayer === desktopLayer) || (innerWidth >= 990 && activeLayer === mobileLayer)) close();
    }, {passive: true, signal});
    window.addEventListener('pageshow', () => { close(); placeLayers(); }, {signal});
    controllers.set(shell, {destroy() { close(); controller.abort(); }});
    placeLayers();
  }
  function initialize(root) {
    if (root.matches?.('[data-sender-header]')) bind(root);
    root.querySelectorAll('[data-sender-header]').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-sender-header]').forEach(shell => { controllers.get(shell)?.destroy(); controllers.delete(shell); });
  });
})();
